import { memo } from 'react';

interface NavigationProgressBarProps {
  isNavigating: boolean;
}

/** Thin indeterminate progress bar shown at viewport top during route transitions. */
export const NavigationProgressBar = memo(function NavigationProgressBar({
  isNavigating,
}: NavigationProgressBarProps) {
  if (!isNavigating) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] overflow-hidden pointer-events-none"
      role="progressbar"
      aria-valuetext="Navigating"
    >
      <div className="h-full w-full bg-primary animate-nav-progress" />
    </div>
  );
});
